export const MailIcon = ({ width = 16, height = 17, fill = 'none' }) => {
    return (
        <svg width={width} height={height} fill={fill} viewBox='0 0 16 17' xmlns='http://www.w3.org/2000/svg'>
            <path d='M2.66659 13.8346C2.29992 13.8346 1.98614 13.7042 1.72525 13.4433C1.46436 13.1824 1.3337 12.8684 1.33325 12.5013V4.5013C1.33325 4.13464 1.46392 3.82086 1.72525 3.55997C1.98659 3.29908 2.30036 3.16841 2.66659 3.16797H13.3333C13.6999 3.16797 14.0139 3.29864 14.2753 3.55997C14.5366 3.8213 14.667 4.13508 14.6666 4.5013V12.5013C14.6666 12.868 14.5361 13.182 14.2753 13.4433C14.0144 13.7046 13.7004 13.8351 13.3333 13.8346H2.66659ZM7.99992 9.16797L13.3333 5.83464V4.5013L7.99992 7.83464L2.66659 4.5013V5.83464L7.99992 9.16797Z' fill='#5C5858' />
        </svg>

    );
};
